export default __webpack_public_path__ + "static/media/Sd-3.99e27e5f.png";